import { useNavigate } from 'react-router-dom';
import { useAuthStore } from '../store/authStore';
import { useFavoritesStore } from '../store/favoritesStore';
import { useToastStore } from '../store/toastStore';

export function useFavoriteToggle() {
  const navigate = useNavigate();
  const isAuthenticated = useAuthStore((s) => s.isAuthenticated);
  const toggleFavorite = useFavoritesStore((s) => s.toggleFavorite);
  // Precisa selecionar favoriteIds (não só a função isFavorited) pra o componente
  // re-renderizar quando a lista mudar — isFavorited tem referência estável no store.
  const favoriteIds = useFavoritesStore((s) => s.favoriteIds);
  const isFavorited = (productId: number) => favoriteIds.includes(productId);
  const showToast = useToastStore((s) => s.show);

  const handleToggle = (productId: number, e?: React.MouseEvent) => {
    e?.preventDefault();
    e?.stopPropagation();

    if (!isAuthenticated) {
      navigate('/login');
      return;
    }

    toggleFavorite(productId).catch(() => {
      showToast('Não foi possível atualizar seus favoritos.', 'error');
    });
  };

  return { isFavorited, handleToggle };
}
